import { render, staticRenderFns } from "./divideTableItem.vue?vue&type=template&id=67214784&scoped=true&"
import script from "./divideTableItem.vue?vue&type=script&lang=js&"
export * from "./divideTableItem.vue?vue&type=script&lang=js&"
import style0 from "./divideTableItem.vue?vue&type=style&index=0&id=67214784&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67214784",
  null
  
)

export default component.exports